module.exports = __webpack_public_path__ + "static/media/timerImg.001dc1c0.svg";